export const DragHandle = (props: React.SVGProps<SVGSVGElement>) => (
	<svg
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="currentColor"
		xmlns="http://www.w3.org/2000/svg"
		data-aid="svgDragHandle"
		{...props}
	>
		<circle cx="9" cy="5" r="1.5" />
		<circle cx="15" cy="5" r="1.5" />
		<circle cx="9" cy="12" r="1.5" />
		<circle cx="15" cy="12" r="1.5" />
		<circle cx="9" cy="19" r="1.5" />
		<circle cx="15" cy="19" r="1.5" />
	</svg>
);
